/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Spotting_ListInputs */



/**
* | output |
* | --- |
* | "SPOTTING LIST" |
*
* @param {Ccsl_Export_Header_Spotting_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_spotting_list = /** @type {((inputs?: Ccsl_Export_Header_Spotting_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Spotting_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("LISTE DE REPERAGE")
	if (locale === "de") return /** @type {LocalizedString} */ ("SPEKTAKELIST")
	if (locale === "it") return /** @type {LocalizedString} */ ("LISTA DI AVVISTAMENTO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("СПИСОК НАБЛЮДЕНИЙ")
	if (locale === "es") return /** @type {LocalizedString} */ ("LISTA DE AVISTAMIENTO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("观测清单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スポッティングリスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पॉटिंग सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("LISTA DE AVISTAMENTOS")
	return /** @type {LocalizedString} */ ("SPOTTING LIST")
});